import styled, { css } from 'styled-components';
import { Button } from 'antd';

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 1.5rem;
	padding-top: 1rem;
`;

export const Icon = styled.div`
	display: flex;
	color: ${({ theme }) => theme.palette.primary.default};
`;

export const Description = styled.p`
	margin: 0;
	text-align: center;
	color: ${({ theme }) => theme.palette.secondary[400]};
	font-size: 1rem;
	font-weight: 400;
	line-height: 1.5rem;
	letter-spacing: -0.005em;
`;

const buttonBase = css`
	height: 2rem;
	padding: 0.5rem 0.75rem;
	border-radius: 0.25rem;
	box-shadow: none;
	font-size: 0.875rem;
	font-weight: 400;
	line-height: 1rem;
	letter-spacing: -0.005em;
`;

export const CancelButton = styled(Button)`
	${buttonBase}
	border: 0.0625rem solid ${({ theme }) => theme.palette.secondary[150]};
	background: ${({ theme }) => theme.palette.secondary.white};
	color: ${({ theme }) => theme.palette.secondary[400]};
`;

export const ConfirmButton = styled(Button)`
	${buttonBase}
	border: 0.0625rem solid ${({ theme }) => theme.palette.primary[600]};
	background: ${({ theme }) => theme.palette.primary[600]};
	color: ${({ theme }) => theme.palette.secondary.white};

	&:hover,
	&:focus {
		border-color: ${({ theme }) => theme.palette.primary[700]};
		background: ${({ theme }) => theme.palette.primary[700]};
		color: ${({ theme }) => theme.palette.secondary.white};
	}
`;
